import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Text, TextTag, TextVariant } from '@enbw/ui-react'
import styles from './styles.module.scss'
import { NoResultsImage } from '@/components/NoResultsImage'

type NoResultsProps = {
  readonly searchQuery: string
}

export const NoResults: FC<NoResultsProps> = ({ searchQuery }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.noResultsContainer}>
      <NoResultsImage />
      <Text variant={TextVariant.BodyStandard} tag={TextTag.P}>
        {t('contracts.noResults.description')}
      </Text>
      <div className={styles.searchQueriesContainer}>
        <Text variant={TextVariant.BodyStandard} tag={TextTag.Span} className={styles.searchQueryValue}>
          &quot;{searchQuery}&quot;
        </Text>
      </div>
      <Text variant={TextVariant.BodyStandard} tag={TextTag.P}>
        {t('contracts.noResults.tryAgain')}
      </Text>
    </div>
  )
}
